import { useState } from 'react';

import { authOptions } from 'api/auth';
// Consume the client generated by the shared APIs library.
import { MFAService } from 'api/shared/mfa/v1/api.pb';
import { useKeycloakContext } from 'containers/App/keycloak/context';

import { getMFAError } from './mfaUtils';
import { useMFAStatus } from './useMFAStatus';

// Prepare conditional enforcement before starting Keycloak's verified enrollment action.
export function useMFAEnrollment() {
  const { data, error, isPending, refetch } = useMFAStatus();
  const { configureTwoFactor, reauthenticateForMFA } = useKeycloakContext();
  const [isStarting, setIsStarting] = useState(false);
  const [actionError, setActionError] = useState('');

  const enable = async () => {
    setActionError('');
    setIsStarting(true);
    try {
      await MFAService.BeginEnrollment({}, authOptions());
      await configureTwoFactor();
    } catch (err) {
      setActionError(getMFAError(err));
    } finally {
      setIsStarting(false);
    }
  };

  const reauthenticate = async () => {
    try {
      await reauthenticateForMFA();
    } catch (err) {
      setActionError(getMFAError(err));
    }
  };
  return {
    data,
    error,
    isPending,
    refetch,
    isStarting,
    actionError,
    enable,
    reauthenticate,
  };
}
